module.exports = __webpack_public_path__ + "static/media/payment-success.a90212a5.svg";